export const AddressActionType = {
    ZIP_CODE_SEARCH: 'address/zip_code_search',
}